import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Select from '../Select';
import translations from './translations';

const DATE_OPTIONS = ['today', 'relativeNow', 'relative', 'date'];

const DateOptions = ({ label, ...props }) => {
  const intl = useIntl();

  return (
    <Select
      {...props}
      label={label || 'Type'}
      suggestions={DATE_OPTIONS.reduce(
        (acc, option) => [
          ...acc,
          { label: intl.formatMessage(translations.dateOptions[option]), value: option },
        ],
        [],
      )}
    />
  );
};

DateOptions.propTypes = {
  label: PropTypes.string,
};

DateOptions.defaultProps = {
  label: undefined,
};

export default DateOptions;
